import React, {ChangeEvent, createRef, Fragment, useEffect, useState} from "react";
import "./EV.css";
import axios, {AxiosResponse} from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import {Col, Row, Form, Button} from "react-bootstrap";
import {Election} from "./Election";
import Private from "./responses/Private"
import ErrorResponse from "./responses/ErrorResponse";
import {Voter} from "./responses/Voter";
import Found from "./responses/Found";
import NotFound from "./responses/NotFound";

export type ConsultaProps = {
    election: Election
}

export const Consulta = (props: ConsultaProps) => {

    const recaptchaRef = createRef<any>();
    const [loading, setLoading] = useState<boolean>(false);
    const [state, setState] = useState<string | null>(null);
    const [voter, setVoter] = useState<Voter | null>(null);
    const [captcha, setCaptcha] = useState<any>(<ReCAPTCHA
        onChange={(value:string|null) => setCaptchaValue(value)}
        sitekey="6Lds5qgUAAAAAFKjDFZSz3Ok0mwGGm3wJm-XCVBG"
    />);
    const [captchaValue, setCaptchaValue] = useState<string | null>(null);
    const [runClasses, setRunClasses] = useState<string>("");
    const [run, setRun] = useState<string | null>(null);

    useEffect(() => {
        recaptchaRef.current && recaptchaRef.current.reset()
    }, [recaptchaRef]);



    const volver = () => {
        setState(null);
        setVoter(null);
        setRun(null);
        setRunClasses("");

    }

    const loadVoter = async () => {
        if (run == null || !validateRut(run)) {
            setRunClasses("is-invalid");
            return;
        }


        if (!captchaValue) {
            window.alert("Debe marcar la casilla 'No Soy un Robot'");
            return;
        }

        setLoading(true);

        try {
            const voter:AxiosResponse<Voter> = await axios({
                method: "post",
                url: process.env.REACT_APP_API_URL + "/election/" + props.election._id +
                    "/run/" +
                    encodeURI(run.replace(/\./g, "")),
                data: {
                    recaptcha: captchaValue
                }
            });

            window.location.href = props.election.configuration.encrypter_url.replace('%s', props.election._id) + '?district=' + voter.data.district.district_id;

        } catch (error) {
            switch (error.response.status) {
                case 401:
                    setState("unpublish");
                    setLoading(false);

                    break
                case 404:
                    setState("notfound");
                    setLoading(false);

                    break
                default:
                    setState("error");
                    setLoading(false);

                    break
            }


        }

    };

    const getDv = (rut: string) => {
        let suma: number = 0;
        for (let i: number = rut.length - 1; i >= 0; i += -1) {
            suma = suma + parseInt(rut.charAt(i), 10) * (2 + (rut.length - 1 - i) % 6);
        }
        suma = 11 - suma % 11;
        switch (suma) {
            case 10:
                return 'K';
            case 11:
                return 0;
            default:
                return suma;
        }
    };


    const verifyAndFixRut = (target: any) => {
        var cdv, dv, noFormat, rut, withFormat;


        noFormat = target.value.replace(/[^0-9kK]/g, "").toUpperCase();
        dv = noFormat.charAt(noFormat.length - 1);
        rut = noFormat.substring(0, noFormat.length - 1);
        withFormat = '';
        while (rut.length > 3) {
            withFormat = "." + rut.substr(rut.length - 3) + withFormat;
            rut = rut.substring(0, rut.length - 3);
        }
        withFormat = rut + withFormat + "-" + dv.toUpperCase();
        if (noFormat.length > 1) {
            target.value = withFormat;
        } else {
            target.value = noFormat;
        }
        cdv = getDv(noFormat.substring(0, noFormat.length - 1)).toString();
        if (dv.toUpperCase() === cdv.toUpperCase()) {
            setRunClasses("is-valid");
            setRun(withFormat);
        } else {
            setRunClasses("");
            setRun(withFormat);
        }
    };

    const validateRut = (rut: string) => {
        var cdv, noFormat;
        noFormat = rut.replace(/[^0-9kK]/g, "").toUpperCase();
        cdv = getDv(noFormat.substring(0, noFormat.length - 1)).toString();
        return noFormat.charAt(noFormat.length - 1).toUpperCase() === cdv.toUpperCase();
    };

    const handleInputChange = (event: ChangeEvent) => {
        verifyAndFixRut(event.currentTarget);
    };

    return (

        <Fragment>
            <Row className={"justify-content-center"}>
                <Col xs={12} sm={11} md={9} lg={7}>
                    <h2>Consulta de datos electorales</h2>
                </Col>
            </Row>

            {state === "unpublish" && <Private election={props.election}/>}
            {state === "error" && <ErrorResponse volver={volver}/>}
            {state === "notfound" && <NotFound volver={volver}/>}

            {!(state || voter) &&
            <Row className={"justify-content-center"}>
                <Col xs={12} sm={11} md={9} lg={7}>
                    <p>Ingrese su RUT, presione "No soy un robot" y el botón "Consultar".</p>

                    {loading ? (
                        <div className={"spinner"}/>
                    ) : (<Form>
                        <Form.Group controlId="run">
                            <Form.Label className="text-white">Ingrese
                                su RUT:</Form.Label>
                            <Form.Control onChange={handleInputChange} type="text" name="run"
                                          placeholder="Ej: 12345678-9" className={runClasses}/>
                            <Form.Control.Feedback type="invalid">
                                RUT incorrecto!, verifique
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Row>
                            <Col sm={6}>
                                {captcha}
                            </Col>
                            <Col sm={6} className={"text-right"}>
                                <Button className="EvColorBlue text-white m-1" onClick={loadVoter}
                                        variant="primary">CONSULTAR</Button>
                                <Button className="EvColorGrisLight m-1"
                                        href={props.election.configuration.home_url}
                                        variant="light">SALIR</Button>
                            </Col>
                        </Row>
                    </Form>)}
                </Col>
            </Row>}

        </Fragment>
    );
}


export default Consulta;
